<template>
  <component v-bind:is="currentComponent"></component>
</template>
<script>
import listarSalas from "../components/salas/Salas.vue";
import cadastrarSala from "../components/salas/CadastrarSala.vue";
import editarSala from "../components/salas/EditarSala.vue";

export default {
  components: {
    listarSalas,
    cadastrarSala,
    editarSala,
  },
  data() {
    return {
      currentComponent: "",
    };
  },
  mounted() {
    this.currentComponent =
      this.$route.query.type === "a"
        ? cadastrarSala
        : this.$route.query.type === "b"
        ? editarSala
        : listarSalas;
  },
  watch: {
    $route(to, from) {
      this.currentComponent =
        to.query.type == "a"
          ? "cadastrarSala"
          : this.$route.query.type === "b"
          ? "editarSala"
          : "listarSalas";
    },
  },
};
</script>
<style scoped></style>
